import * as z from "zod/v4";

export const deleteSlackMessage = {
  name: "deleteSlackMessage" as const,
  input: z.object({ slackUrl: z.string().min(1, "Slack URL is required") }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
